<template>
  <header class="header">
    <div class="container">
      <div class="logo">
        <img src="@/assets/images/logo.png" alt="VOSDOM Logo" class="logo-img">
      </div>
      <nav class="nav">
        <ul>
          <li>
            <router-link to="/" exact-active-class="active">
              <div class="nav-text">首页</div>
              <div class="nav-text-en">Home</div>
            </router-link>
          </li>
          <li>
            <router-link to="/products" exact-active-class="active">
              <div class="nav-text">产品中心</div>
              <div class="nav-text-en">Products</div>
            </router-link>
          </li>
          <li>
            <router-link to="/about" exact-active-class="active">
              <div class="nav-text">关于我们</div>
              <div class="nav-text-en">About Us</div>
            </router-link>
          </li>
          <li>
            <router-link to="/contact" exact-active-class="active">
              <div class="nav-text">联系我们</div>
              <div class="nav-text-en">Contact</div>
            </router-link>
          </li>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: 'SiteHeader'
}
</script>

<style scoped>
.header {
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0,0,0,.1);
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}

.logo-img {
  height: 45px;
  width: auto;
  padding: 5px 0;
}

.nav ul {
  list-style: none;
  display: flex;
}

.nav li {
  margin-left: 30px;
}

.nav a {
  text-decoration: none;
  color: #333;
  font-weight: 500;
  transition: color 0.3s;
  padding: 15px 0;
  display: block;
  text-align: center;
}

.nav a:hover,
.nav a.active {
  color: #409eff;
}

.nav-text {
  font-size: 16px;
}

.nav-text-en {
  font-size: 12px;
  color: #999;
  margin-top: 2px;
}

.nav a:hover .nav-text-en,
.nav a.active .nav-text-en {
  color: #409eff;
}

@media (max-width: 768px) {
  .container {
    flex-direction: column;
    padding: 10px 20px;
  }
  
  .nav ul {
    flex-wrap: wrap;
    justify-content: center;
  }
  
  .nav li {
    margin: 5px 10px;
  }
  
  .logo-img {
    height: 50px;
  }
}
</style>